<template>
  <article>
    <p>
      Across the wine world, different regions are known for producing different
      grapes and subsequently different styles of wine.
    </p>
    <p>
      The distinction between Old World wine regions and New World wine regions
      is particularly important: as a sweeping generalization, Old World regions
      are known for producing wines that are more austere and terroir-driven,
      while New World regions are known for producing wines with greater
      intensity. For example, Cabernet Sauvignon grapes grown in France will
      likely produce wines marked by earthiness and subtle fruit flavors, while
      Cabernet Sauvignon grapes grown in California will likely produce wines
      that are more fruit-forward.
    </p>
    <p>
      But different wine regions are also often associated with the production
      of different grapes. For example, within France, Bordeaux is associated
      with red wines made primarily from Cabernet Sauvignon, Merlot, and
      Cabernet Franc grapes, while Burgundy is associated with red wines made
      from the Pinot Noir grape.
    </p>
    <p>
      There are many notable wine regions around the world. Take the Loire
      Valley, a well known wine region in central France that spans 300 miles.
      In Spain, you can find the La Rioja wine region, an autonomous community
      located in the north of the Iberian Peninsula. In New Zealand, there is
      the Waitaki Valley, a small wine region in North Otago on the east coast
      of the South Island. There is also Central Otago, the world's
      southern-most commercial wine growing region. Also in New Zealand you can
      find Hawkes Bay which not only is the second largest wine region in New
      Zealand but also the oldest. Not too far away is Yarra Valley in
      Australia, just 90 kilometers east of Melbourne. You can also find Mclaren
      Vale, Australia's premium food and wine region located in the town of
      McLaren. Zooming over to North America, you can find the Paso Robles wine
      region located halfway between Los Angeles and San Francisco. In Northern
      California, Sonoma County houses well over 400 wineries. Then there is
      Willamette Valley, home to two-thirds of Oregon's wineries and vineyards.
      There is also Mendoza Argentinas, considered to be Argentina's most
      important wine region.
    </p>
    <p>
      The list of major wine regions only goes on from there. There is the Douro
      Valley wine producing region in Northern Portugal. There are also famous
      wine regions in Santa Barbara, North Canterbury, British Columbia (where
      you can find Okanagan Valley), South Australia, Cape Town, and Russian
      River Valley.
    </p>
    <p>
      Wine production is big business, and there are plenty of wine growing
      regions around the world to meet global and local demand. On a side note,
      Napa Valley is recommended if you're looking for some of the best wine
      tours in the United States!
    </p>
    <p>
      Use this page to find top-rated wines from wine regions throughout the
      world and learn about each region's wine-making profile.
    </p>
    <p>
      Across the wine world, different regions are known for both producing
      different grapes and different styles of wine.
    </p>

    <p>
      The distinction between Old World wine regions and New World wine regions
      is particularly important: as a sweeping generalization, Old World regions
      are known for producing wines that are more austere and terroir driven,
      while New World regions are known for producing wines with greater
      intensity. For example, Cabernet Sauvignon grapes grown in France will
      likely produce wines marked by earthiness and subtle fruit flavors, while
      Cabernet Sauvignon grapes grown in California will likely produce wines
      that are more fruit-forward.
    </p>

    <p>
      But different wine regions are also often associated with the production
      of different grapes. For example, within France, Bordeaux is associated
      with red wines made primarily from Cabernet Sauvignon, Merlot, and
      Cabernet Franc grapes, while Burgundy is associated with red wines made
      from the Pinot Noir grape. Use this page to find top-rated wines from wine
      regions throughout the world and learn about each region’s wine-making
      profile.
    </p>
    <div class="wineries">
      <ul class="multilevel nobullet">
        <li><a href="/winery/allegrini/">Allegrini</a></li>

        <li><a href="/winery/anselmi/">Anselmi</a></li>

        <li>
          <a href="/winery/beringer-vineyards/">Beringer Vineyards</a>
        </li>

        <li>
          <a href="/winery/chateau-cheval-blanc/">Chateau Cheval Blanc</a>
        </li>

        <li>
          <a href="/winery/champagne-bollinger/">Champagne Bollinger</a>
        </li>

        <li>
          <a href="/winery/chateau-pontet-canet/">Chateau Pontet-Canet</a>
        </li>

        <li><a href="/winery/caymus-vineyards/">Caymus Vineyards</a></li>

        <li>
          <a href="/winery/domaine-de-chevalier/">Domaine de Chevalier</a>
        </li>

        <li><a href="/winery/moet-et-chandon/">Moet et Chandon</a></li>

        <li>
          <a href="/winery/duckhorn-vineyards/">Duckhorn Vineyards</a>
        </li>

        <li><a href="/winery/screaming-eagle/">Screaming Eagle</a></li>

        <li><a href="/winery/perrier-jouet/">Perrier Jouet</a></li>

        <li><a href="/winery/louis-latour/">Louis Latour</a></li>

        <li><a href="/winery/chateau-latour/">Chateau Latour</a></li>

        <li><a href="/winery/laurent-perrier/">Laurent-Perrier</a></li>

        <li><a href="/winery/chateau-margaux/">Chateau Margaux</a></li>

        <li><a href="/winery/navarro/">Navarro</a></li>

        <li><a href="/winery/opus-one/">Opus One</a></li>

        <li><a href="/winery/palmer/">Palmer</a></li>

        <li>
          <a href="/winery/chateau-pape-clement/">Chateau Pape Clement</a>
        </li>

        <li>
          <a href="/winery/chateau-lafite-rothschild/"
            >Chateau Lafite-Rothschild</a
          >
        </li>

        <li><a href="/winery/schafer/">Schafer</a></li>

        <li><a href="/winery/silver-oak-cellars/">Silver Oak</a></li>

        <li>
          <a href="/winery/chateau-smith-haut-lafitte/"
            >Chateau Smith Haut Lafitte</a
          >
        </li>

        <li><a href="/winery/taittinger/">Taittinger</a></li>

        <li>
          <a href="/winery/turley-wine-cellars/">Turley Wine Cellars</a>
        </li>

        <li>
          <a href="/winery/stolpman-vineyards/">Stolpman Vineyards</a>
        </li>

        <li><a href="/winery/abreu/">Abreu</a></li>

        <li><a href="/winery/luca/">Luca</a></li>

        <li><a href="/winery/arietta/">Arietta</a></li>

        <li><a href="/winery/hourglass/">Hourglass</a></li>

        <li><a href="/winery/bond/">BOND</a></li>

        <li><a href="/winery/tor-wines/">TOR Wines</a></li>

        <li>
          <a href="/winery/cliff-lede-vineyards/">Cliff Lede Vineyards</a>
        </li>

        <li><a href="/winery/larkin/">Larkin</a></li>

        <li><a href="/winery/favia/">Favia</a></li>

        <li><a href="/winery/matthiasson/">Matthiasson</a></li>

        <li><a href="/winery/angelus/">Angelus</a></li>

        <li><a href="/winery/martinelli/">Martinelli</a></li>

        <li><a href="/winery/montagna/">Montagna</a></li>

        <li><a href="/winery/carte-blanche/">Carte Blanche</a></li>

        <li>
          <a href="/winery/chateau-ste-michelle/">Chateau Ste Michelle</a>
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
export default {
  head: {
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Across the wine world, different regions are known for producing different grapes and subsequently different styles of wine.',
      },
    ],
  },
}
</script>

<style scoped lang="scss">
div.wineries {
  columns: 3;
  column-gap: 30px;
  column-rule: 1px solid #c9c9c9;
  max-width: 1000px;
  margin: 0 auto;
}
ul.multilevel li {
  font-size: 1.25rem;
}
</style>
